import { Injectable } from '@angular/core';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { NotificationsRegistrationService } from '@core/services/core/notifications/notifications-registration.service';
import { UiHelperService } from '@core/services/core/ui-helper.service';
import { FirstRunHelperService } from '@core/services/helpers/first-run-helper.service';
import { Platform } from '@ionic/angular';
import { AllFeatureFlags } from '@models/mmobile';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsHelperService {

  constructor(
    private notificationsRegistration: NotificationsRegistrationService,
    private firstRunService: FirstRunHelperService,
    private platform: Platform,
    private ui: UiHelperService,
    private trans: TranslateService,
    private mmobileHelper: MMobileHelperService
  ) {}

  setDefaulSFMCNotificationsPreference() {
    this.firstRunService.isFirstAppRun().then(isFirstTime => {
      const requestDefaultPreferenceEnabled =
        this.mmobileHelper.checkIsFeatureEnabled(AllFeatureFlags.REQUEST_DEFAULT_NOTIFICATIONS_PREFERENCE);
      if (isFirstTime) {
        if (this.platform.is('android') && requestDefaultPreferenceEnabled) {
          this.requestMarketingCloudUserPushPreference();
        } else {
          this.notificationsRegistration.disableMarketingCloudUserPush();
        }
      }
    });
  }

  private requestMarketingCloudUserPushPreference() {
    this.ui.presentBigCustomAlertTwoButtons(
      this.trans.instant('PROFILE.PUSH_NOTIFICATIONS.REQUEST_PREFERENCES.TITLE'),
      this.trans.instant('PROFILE.PUSH_NOTIFICATIONS.REQUEST_PREFERENCES.DESCRIPTION'),
      () => {
        this.notificationsRegistration.enableSFMCUserPush();
      },
      () => {
        this.notificationsRegistration.disableMarketingCloudUserPush();
      },
      this.trans.instant('PROFILE.PUSH_NOTIFICATIONS.REQUEST_PREFERENCES.ALLOW'),
      this.trans.instant('PROFILE.PUSH_NOTIFICATIONS.REQUEST_PREFERENCES.DO_NOT_ALLOW')
    );
  }
}
